/**
 * Tolerant parser for boolean-ish build flags (VITE_* secrets typed by humans
 * into GitHub/Dokploy UIs). `recognized: false` means a NON-EMPTY value that
 * matches neither table — i.e. someone set the flag but got the spelling wrong
 * ('TRUE ', 'enabled', 'VITE_X=1' pasted as the value…). Callers should warn
 * loudly on that case: a silently-ignored flag cost us a day of map debugging.
 */
export function parseBooleanFlag(raw: string | undefined): {
  enabled: boolean;
  recognized: boolean;
} {
  const normalized = (raw ?? '').trim().toLowerCase();
  if (normalized === '') return { enabled: false, recognized: true };
  if (['1', 'true', 'yes', 'on'].includes(normalized)) return { enabled: true, recognized: true };
  if (['0', 'false', 'no', 'off'].includes(normalized)) {
    return { enabled: false, recognized: true };
  }
  return { enabled: false, recognized: false };
}
